export const urlAdapter = (url, replaceStr, newStr) =>
  url.replace(replaceStr, newStr);
